export default __webpack_public_path__ + "static/media/Blessed Gem.d07123dd.jpg";